import React from 'react';
import { useTranslation } from 'react-i18next';
import { Descriptions } from 'antd';
import '../../pages/Sensors/sensors.scss';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  showCheckData: boolean;
  closeModal: () => void;
  row: any;
  cdSensorId: string;
  cdData: string;
  cdWrongData: boolean;
  cdNoTransmissions: boolean;
  cdDate: string;
}

const CheckDataSensorsModal = ({
  showCheckData,
  closeModal,
  row,
  cdSensorId,
  cdData,
  cdWrongData,
  cdNoTransmissions,
  cdDate
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog className='dialog' open={showCheckData} fullWidth onClose={closeModal}>
      <DialogTitle>{row?.sensor_id}</DialogTitle>

      <DialogContent>
        <Descriptions size="default" bordered>
          <Descriptions.Item span={10} label={<b>{t('SENSOR_ID')}:</b>}>
            {cdSensorId ?? '-'}
          </Descriptions.Item>
          <Descriptions.Item span={10} label={<b>{t('DATE')}:</b>}>
            {cdDate}
          </Descriptions.Item>
          <Descriptions.Item span={10} label={<b>{t('DATA')}:</b>}>
            {cdData}
          </Descriptions.Item>
          <Descriptions.Item span={10} label={<b>{t('WRONG_DATA')}:</b>}>
            {cdWrongData.toString()}
          </Descriptions.Item>
          <Descriptions.Item span={10} label={<b>{t('NO_TRANSMISSIONS')}:</b>}>
            {cdNoTransmissions.toString()}
          </Descriptions.Item>
        </Descriptions>
      </DialogContent>
    </Dialog>
  );
};

export default CheckDataSensorsModal;
